<template>
    <v-card-text>
        <v-text-field :label="label" :hint="hint" type="number" v-model="val" persistent-hint filled @keydown.enter.stop.prevent :rules="[v => v!=='']"/>

        <v-row v-if="timestamp !== 0" class="px-4 pt-2 pb-4" justify="space-between" align="center">
            <p class="font-16 mb-0">
                <span class="font-weight-bold">Jauge Fuel IT</span><br />
                {{ valueName }}* : <span class="font-weight-bold">{{ expectedMeasure }}{{ unity }}</span>
            </p>
            <div class="d-flex flex-column align-end">
                <v-chip outlined>{{ il_y_a }}</v-chip>
                <v-chip v-if="isManualReading" color="primary" text-color="white" small class="mt-2">
                    Relevé manuel
                </v-chip>
            </div>
        </v-row>

        <div v-if="displayValidity">
            <p class="text-right mb-0 px-4">* Donnée provenant de FUEL IT.</p>
            <v-alert shaped text :type="validInput">{{ valueName }} {{ valueCompliance }}</v-alert>
        </div>
    </v-card-text>
</template>

<script>
import moment from "moment";

export default {
    name: "AppGaugingCheck",
    props: {
        label: {
            type: String,
            required: false,
            default: "Jaugeage manuel de la cuve avec mètre ruban *",
        },
        hint: {
            type: String,
            required: false,
            default: "Renseigner en litre ou cm",
        },
        "expected-measure": {
            type: Number,
            required: true,
        },
        timestamp: {
            type: Number,
            required: true,
        },
        declencheur: {
            type: Number,
            required: false,
            default: null,
        },
        unity: {
            type: String,
            required: false,
            default: "cm",
        },
        valueName: {
            type: String,
            required: false,
            default: "Hauteur de liquide",
        },
        offset: {
            type: Number,
            required: false,
            default: 3,
        },
        value: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        const savedValue = this.value?.value
        const hasSavedValue = savedValue !== undefined && savedValue !== null && savedValue >= 0
        return {
            val: hasSavedValue ? String(savedValue) : "",
            displayValidity: hasSavedValue,
        };
    },
    computed: {
        il_y_a() {
            moment.locale("fr");
            return moment.unix(this.timestamp).fromNow();
        },
        isManualReading() {
            return this.declencheur === 3 || this.declencheur === -4;
        },
        isValidValue() {
            const numVal = parseFloat(this.val);
            const TOLERANCE_CM = 2;
            return !isNaN(numVal) && Math.abs(numVal - this.expectedMeasure) <= TOLERANCE_CM;
        },
        validInput() {
            return this.isValidValue ? "success" : "warning";
        },
        valueCompliance() {
            return this.isValidValue ? "cohérente" : "incohérente";
        },
    },
    watch: {
        val: 'recomputeValidity',
        // Re-emit when expectedMeasure arrives from API — val may already be filled
        expectedMeasure: 'recomputeValidity',
    },
    methods: {
        recomputeValidity() {
            if (this.val === '') return
            const numVal = parseFloat(this.val)
            const isValid = !isNaN(numVal) && numVal >= 0 && Math.abs(numVal - this.expectedMeasure) <= 2
            this.displayValidity = !isNaN(numVal) && numVal >= 0
            this.$emit("input", {
                value: isNaN(numVal) ? -1 : numVal,
                expected: this.expectedMeasure,
                valid: isValid,
            })
        },
    },
};
</script>
